import React from "react";

import css from "./Column.module.css";

import cn from "classnames";

type ColumnProps = {
    noGap?: boolean;
    className?: string;
    gap?: "4px" | "12px" | "20px" | "40px";
    onClick?: () => void;
    align?: "center" | "start" | "end";
    overflow?: "hidden" | "auto";
};

export const Column: React.FC<React.PropsWithChildren<ColumnProps>> = ({
    children,
    noGap,
    className,
    gap = "12px",
    onClick,
    align,
    overflow,
}) => {
    return (
        <div
            className={cn(css.main, noGap && css.noGap, className)}
            style={{ gap, alignItems: align, overflow }}
            onClick={onClick}
        >
            {children}
        </div>
    );
};
